import { Box, ButtonNew, ColorOptions, convertHexToRGBA, SpacerNew, Text } from '@jfs/ui-new'
import React from 'react'
import WarningIcon from '../../../assets/svg/WarningIcon'
import { isIE } from '../../../utils'
import { Modal } from '../../Modal'

interface ModalDialogDeleteProps {
  show: boolean
  onDismiss: () => void
  onProceed: () => void
  title?: string
  data?: any
  theme?: any
  isLoading?: boolean
}

export const ModalDialogDelete = ({
  show,
  onDismiss,
  onProceed,
  title,
  theme,
  isLoading,
  data,
}: ModalDialogDeleteProps) => {
  const getContent = () => {
    return (
      <Box
        flexDirection={'column'}
        minHeight={100}
        //height={Dimensions.get('window').height / 3}
        pv={32}
        ph={42}
        justifyContent={'center'}
        overflow={'hidden'}
        alignItems={'center'}
        zIndex={99999}>
        <Box maxWidth={320} justifyContent={'center'} alignItems={'center'}>
          <WarningIcon width={40} height={40} />
          <SpacerNew size={25} direction="vertical" />
          <Text fontFamily="jiotype-bold" fontSize={18} color={theme.bodyTextColor as ColorOptions}>
            Delete Saved Card ?
          </Text>
          <SpacerNew size={16} direction="vertical" />
          <Box>
            <Text
              textAlign="center"
              lineHeight={22}
              fontFamily={'jiotype-medium'}
              color={convertHexToRGBA(theme.bodyTextColor, 40) as ColorOptions}
              fontSize={12}>
              {`Are you sure you want to delete your card `}
              <Text textAlign="center" lineHeight={22} color={theme.bodyTextColor} fontFamily="jiotype-bold">
                {data?.cardNumber?.substr(data?.cardNumber?.length - 6)}
              </Text>
              {` ? Once deleted your card won't be available in your preferred payment methods`}
            </Text>
          </Box>
        </Box>
        <SpacerNew size={32} direction="vertical" />
        <Box flexDirection={'column'} width={'100%'}>
          <ButtonNew
            title={'No, Keep the card saved'}
            onPress={onDismiss}
            type="secondaryFullWidth"
            borderColor={theme.brandColor as ColorOptions}
            color={theme.bodyBgColor as ColorOptions}
            titleColor={theme.brandColor as ColorOptions}
            hoverColor={convertHexToRGBA(theme.brandColor, 12) as ColorOptions}
            underlayColor={'ALTO_DISABLED'}
            height={48}
            width={'100%'}
          />
          <SpacerNew size={16} direction="vertical" />
          <ButtonNew
            title={'Yes, Delete the card'}
            onPress={onProceed}
            type="primaryFullWidth"
            color={theme.brandColor as ColorOptions}
            hoverColor={convertHexToRGBA(theme.brandColor, 80) as ColorOptions}
            titleColor={theme.bodyBgColor as ColorOptions}
            underlayColor={convertHexToRGBA(theme.brandColor, 90) as ColorOptions}
            height={48}
            width={'100%'}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    )
  }
  return (
    <>
      <Modal
        show={show}
        type={'Bottom'}
        title={title}
        onDismiss={onDismiss}
        children={getContent()}
        theme={theme}
        containerTopPadding={isIE() ? 5 : undefined}
      />
    </>
  )
}
